import {SystemMemoryProps} from "../../models/SystemMemoryProps";
import {NavMenu} from "../../components/GetNavMenu";
import {Tabs, Space, Title, Box} from "@mantine/core";
import {Footer} from "../../components/GetFooter";
import React, {useEffect, useState} from "react";
import {useStyles} from "../../models/styles/NotFoundStyle";
import {IconBrandGit, IconTags, IconProgressBolt} from "@tabler/icons-react";
import {AdminCommissionsStatuses} from "../../components/admin/commissions/AdminCommissionsStatuses";
import {AdminPortfolioTags} from "../../components/admin/portfolio/AdminPortfolioTags";
import {useLocation} from "react-router-dom";

export function PortfolioAdmin({memory}: SystemMemoryProps) {
    // Check if the user has supplied a page number in the URL
    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);
    let page = parseInt(queryParams.get("page") || "1");


    const { classes } = useStyles();

    // Portfolio admin states
    const [portfolioAdminPage, setPortfolioAdminPage] = useState(<></>)

    function PortfolioAdminNavigation(id: number) {
        // update the param
        queryParams.set("page", id.toString());

        // build new URL
        const newUrl = window.location.pathname + "?" + queryParams.toString();

        // update the browser address bar (without reload)
        window.history.replaceState(null, "", newUrl);

        switch (id) {
            case 1:
                setPortfolioAdminPage(<></>);
                return
            case 2:
                setPortfolioAdminPage(<AdminPortfolioTags memory={memory} />);
                return
            case 3:
                setPortfolioAdminPage(<AdminCommissionsStatuses memory={memory} />);
                return
            default:
                setPortfolioAdminPage(<></>);
                return
        }
    }

    // Load page
    useEffect(() => { PortfolioAdminNavigation(page) }, []);

    return (
        <>
            <NavMenu memory={memory}></NavMenu>
            <Space h="lg" />
            <Title order={1} className={classes.title}>Manage Portfolios</Title>
            <Tabs color="indigo" defaultValue={page.toString()} p={'lg'}>
                <Tabs.List grow position="center">
                    <Tabs.Tab value="1" icon={<IconBrandGit size="0.9rem" />} onClick={() => {PortfolioAdminNavigation(1)}}>Portfolios</Tabs.Tab>
                    <Tabs.Tab value="2" icon={<IconTags size="0.9rem" />} onClick={() => {PortfolioAdminNavigation(2)}}>Portfolio Tags</Tabs.Tab>
                    <Tabs.Tab value="3" icon={<IconProgressBolt size="0.9rem" />} onClick={() => {PortfolioAdminNavigation(3)}}>Portfolio Statuses</Tabs.Tab>
                </Tabs.List>

            </Tabs>

            <Box p={'md'}>{portfolioAdminPage}</Box>

            <Footer data={[]}></Footer>
                </>
    );
}